"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _contentType = require("@insided/shared/utils/contentType");

var _validation = require("@insided/shared/utils/validation");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _topicService = require("@insided/shared/services/topicService");

var _categories = require("@insided/shared/utils/categories");

var _CategoryDropdown = _interopRequireDefault(require("@insided/shared/uikit/CategoryDropdown"));

var _Modal = require("@insided/shared/uikit/Modal");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Categories = require("@insided/shared/modules/Categories");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getSuccessMessage = function getSuccessMessage(privateId, title) {
  var topicUrl = "".concat(globalThis.location.origin, "/").concat(_contentType.CONTENT_TYPE_CONVERSATION, "s/").concat(privateId);
  var topicLink = "<a href=\"".concat(topicUrl, "\">").concat(title, "</a>");
  return "The reply has been successfully promoted to ".concat(topicLink);
};

var PromoteReplyToNewTopicModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(PromoteReplyToNewTopicModal, _PureComponent);

  var _super = _createSuper(PromoteReplyToNewTopicModal);

  function PromoteReplyToNewTopicModal() {
    var _this;

    (0, _classCallCheck2.default)(this, PromoteReplyToNewTopicModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      title: '',
      categoryId: null,
      isLoading: false,
      categories: {}
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var onShowAlert, categoriesData;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onShowAlert = _this.props.onShowAlert;
              _context.prev = 1;
              _context.next = 4;
              return (0, _Categories.getCategoriesList)([(0, _categories.getTypeFromModuleName)(_categories.MODULE.KNOWLEDGE_BASE), (0, _categories.getTypeFromModuleName)(_categories.MODULE.COMMUNITY), (0, _categories.getTypeFromModuleName)(_categories.MODULE.GROUPS)]);

            case 4:
              categoriesData = _context.sent;

              _this.setState({
                categories: categoriesData !== null && categoriesData !== void 0 ? categoriesData : null
              });

              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);
              onShowAlert('error');

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeTitle", function (title) {
      _this.setState({
        title: title
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeCategory", function (categoryId) {
      _this.setState({
        categoryId: categoryId
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectCategory", function (category) {
      _this.setState({
        categoryId: category.id
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPromoteReplyToNewTopic", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var _this$props, contentType, replyId, onShowAlert, onClose, getReplies, _this$state, title, categoryId, privateId;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props = _this.props, contentType = _this$props.contentType, replyId = _this$props.replyId, onShowAlert = _this$props.onShowAlert, onClose = _this$props.onClose, getReplies = _this$props.getReplies;
              _this$state = _this.state, title = _this$state.title, categoryId = _this$state.categoryId;

              if (categoryId) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return");

            case 4:
              _this.setState({
                isLoading: true
              });

              _context3.prev = 5;
              _context3.next = 8;
              return (0, _topicService.promoteReply)(contentType, replyId, title, categoryId);

            case 8:
              privateId = _context3.sent;
              onClose();
              onShowAlert('success', getSuccessMessage(privateId, title));
              setTimeout( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
                return _regenerator.default.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return getReplies();

                      case 2:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              })), 500);
              _context3.next = 17;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](5);
              onShowAlert('error');

            case 17:
              _this.setState({
                isLoading: false
              });

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[5, 14]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(PromoteReplyToNewTopicModal, [{
    key: "render",
    value: function render() {
      var _category$title,
          _this2 = this;

      var onClose = this.props.onClose;
      var _this$state2 = this.state,
          isLoading = _this$state2.isLoading,
          title = _this$state2.title,
          categoryId = _this$state2.categoryId,
          categories = _this$state2.categories;
      var disablePromoteButton = title.length < _validation.MIN_TITLE_LENGTH || categoryId === null;
      var category = categoryId && categories ? (0, _categories.findCategoryById)(Object.values(categories).flat(), categoryId) : null;
      var categoryTitle = (_category$title = category === null || category === void 0 ? void 0 : category.title) !== null && _category$title !== void 0 ? _category$title : 'Select category';
      return (0, _preact.h)(_Modal.Modal, {
        isOpen: true,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Promote to new topic",
        onClose: onClose
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)(_InputGroup.default, {
        title: "Create a new topic for this post",
        id: "promote-to-new-topic",
        name: "promote-to-new-topic",
        type: "text",
        value: title,
        placeholder: "Enter a title here",
        onInput: function onInput(e) {
          return _this2.onChangeTitle(e.target.value);
        }
      }), (0, _preact.h)(_InputGroup.default, {
        customInput: (0, _preact.h)(_CategoryDropdown.default, {
          categories: categories,
          onSelectCategory: this.onSelectCategory,
          trigger: (0, _preact.h)(_Button.default, {
            title: categoryTitle,
            endIcon: "chevronDown",
            size: "medium",
            fullWidth: true,
            "data-qa": "select-category"
          }),
          triggerClass: "dropdown-selector-wrapper--control",
          searchable: true
        })
      })), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
        title: "Promote to new topic",
        variant: "primary",
        onClick: this.onPromoteReplyToNewTopic,
        isLoading: isLoading,
        disabled: disablePromoteButton,
        size: "medium",
        "data-qa": "promote-to-new-topic"
      })));
    }
  }]);
  return PromoteReplyToNewTopicModal;
}(_preactCompat.PureComponent);

var _default = PromoteReplyToNewTopicModal;
exports.default = _default;